import React, { useState, useEffect } from "react";
import "./Header.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import whiteL from "../../Asset/codiffi-logo-white.svg";
import logo from "../../Asset/codiffi-logo.svg";
import bikar from "../../Asset/AI-animation-blue.svg";
import bikar2 from "../../Asset/AI-animation.svg";
import { Image } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { FaAngleDown } from "react-icons/fa";
import whoweAre from "../../Asset/what-we-are.png";
import service from "../../Asset/services.png";
import indus from "../../Asset/industries.png";
import "../../App.css";
import svgIcon from "../../svg/svgIcon";
import data1 from "../../data.json";
import data2 from "../../data2.json";
import data3 from "../../data3.json";
import { NavLink, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [isNavbarExpanded, setIsNavbarExpanded] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleMouseEnter = (menu) => {
    setHoveredMenu(menu);
  };

  const handleMouseLeave = () => {
    setHoveredMenu(null);
  };

  const handleToggle = () => {
    setIsNavbarExpanded(!isNavbarExpanded);
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrolledRoutes = [
    "/CompanyOverview",
    "/howweWork",
    "/Services",
    "/lifeAtWeb",
    "/careers",
    "/ContactUs",
    "/mobileApp",
    "/webDevelopment",
    "/Iot",
    "/uiUx",
    "/dedicatedDevelopers",
    "/indusAutomation",
    "/Services",
    "/indus",
    "/indus/fintech",
    "/eCommerce",
    "/indus/logistic",
    "/portfolio",
    "/Blog",
    "/ai",
    "/Blog/Card1",
    "/Portfolio/InnerPortfolio",
    "/term&conditions",
    "/privacypolicy",
    "/testimonials",
  ];

  const isScrolledRoute = scrolledRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  const getLogo = () => {
    if (isNavbarExpanded || isScrolled || isScrolledRoute) {
      return logo;
    } else {
      return whiteL;
    }
  };

  return (
    <header>
      <Container fluid>
        <Navbar
          expand="lg"
          className={`bg-body-tertiary navBar ${
            isNavbarExpanded ? "expanded-nav" : "navBar"
          } ${isScrolled || isScrolledRoute ? "scrolled" : ""}`}
        >
          <Container>
            <Navbar.Brand href="/">
              <Image alt="Logo" className="logo" src={getLogo()} />
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className={`custom-navbar-toggle ${
                isNavbarExpanded ? "expanded-toggle" : "custom-navbar-toggle"
              }`}
              onClick={handleToggle}
            />
            <Navbar.Collapse
              id="basic-navbar-nav"
              className="justify-content-end"
            >
              <Nav className="top-header">
                <div
                  className="menu-item"
                  onMouseEnter={() => handleMouseEnter("whoWeAre")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavLink
                    to={window.innerWidth <= 991 ? "#" : "/CompanyOverview"}
                    className="main-menu"
                  >
                    Who we are <FaAngleDown className="icon" />
                  </NavLink>
                  {hoveredMenu === "whoWeAre" && (
                    <ul className="sub-menu">
                      <div className="left-portion">
                        {data1?.map((item) => (
                          <li key={item?.id}>
                            <NavLink to={item?.navigation}>
                              <span id="svg">{svgIcon(item?.icon)}</span>
                              <span>{item?.name}</span>
                            </NavLink>
                          </li>
                        ))}
                      </div>
                      <div className="right-portion">
                        <img src={whoweAre} alt="Who We Are" />
                        <div className="card">
                          <h3>
                            Who we <strong>Are</strong>
                          </h3>
                          <div className="content">
                            Codeffi aspires to be one of the leading digital
                            product development company
                          </div>
                        </div>
                      </div>
                    </ul>
                  )}
                </div>

                <div
                  className="menu-item"
                  onMouseEnter={() => handleMouseEnter("services")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavLink
                    to={window.innerWidth <= 991 ? "#" : "/Services"}
                    className="main-menu"
                  >
                    Services <FaAngleDown className="icon" />
                  </NavLink>
                  {hoveredMenu === "services" && (
                    <ul className="sub-menu">
                      <div className="left-portion">
                        {data2?.map((item) => (
                          <li key={item?.id}>
                            <NavLink to={item?.navigation}>
                              <span id="svg">{svgIcon(item?.icon)}</span>
                              <span>{item?.name}</span>
                            </NavLink>
                          </li>
                        ))}
                      </div>
                      <div className="right-portion">
                        <img src={service} alt="Services" />
                        <div className="card">
                          <h3>
                            Our <strong>Services</strong>
                          </h3>
                          <div className="content">
                            Our awesome services to give you success
                          </div>
                        </div>
                      </div>
                    </ul>
                  )}
                </div>

                <div
                  className="menu-item"
                  onMouseEnter={() => handleMouseEnter("industries")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavLink
                    to={window.innerWidth <= 991 ? "#" : "/indus"}
                    className="main-menu"
                  >
                    Industries <FaAngleDown className="icon" />
                  </NavLink>
                  {hoveredMenu === "industries" && (
                    <ul className="sub-menu">
                      <div className="left-portion">
                        {data3?.map((item) => (
                          <li key={item?.id}>
                            <NavLink to={item?.navigation}>
                              <span id="svg">{svgIcon(item?.icon)}</span>
                              <span>{item?.name}</span>
                            </NavLink>
                          </li>
                        ))}
                      </div>
                      <div className="right-portion">
                        <img src={indus} alt="Industries" />
                        <div className="card last-c">
                          <h3>
                            Industries <strong>We Serve</strong>
                          </h3>
                          <div className="content">
                            850+ projects delivered & counting...
                          </div>
                        </div>
                      </div>
                    </ul>
                  )}
                </div>
                <div className="menu-item">
                  <NavLink to="/portfolio" className="main-menu">
                    Portfolio
                  </NavLink>
                </div>
                <div className="menu-item">
                  <NavLink to="/Blog" className="main-menu">
                    Blog
                  </NavLink>
                </div>
                <NavLink to="/ai" className="xmain-menu">
                  <Image
                    src={
                      isNavbarExpanded || isScrolled || isScrolledRoute
                        ? bikar2
                        : bikar
                    }
                    className="bikar"
                    alt="AI GIF"
                  />
                </NavLink>
                <NavLink to="/ContactUs">
                  <Button className="button">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill=""
                      xmlns="http://www.w3.org/2000/svg"
                      className="callIcon"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.64861 5.84078L5.38673 6.85398C6.18314 8.47632 7.5022 9.79539 9.12501 10.5923L10.1581 9.33132C10.3618 9.07867 10.7134 8.99125 11.0129 9.12097L13.5559 10.2111C13.8617 10.372 14.061 10.7282 13.9813 11.0704L13.4363 13.4329C13.3598 13.7669 13.0663 14.0005 12.7224 14.0005C6.80939 14.0001 2.00001 9.1907 2.00001 3.27742C2.00001 2.93382 2.23366 2.63992 2.56767 2.56375L4.93017 2.01882C5.27423 1.93909 5.62579 2.11768 5.76876 2.44351L6.85907 4.98648C6.98653 5.28601 6.90056 5.635 6.64861 5.84078ZM4.63759 0.752177C5.59998 0.529808 6.56908 1.03207 6.9592 1.92116L6.96361 1.93121L8.05529 4.47748C8.40897 5.30868 8.17129 6.27563 7.47095 6.84763L7.46255 6.85449L7.07407 7.16635C7.54654 7.8477 8.13941 8.43962 8.82176 8.91116L9.1501 8.51043C9.72032 7.80758 10.6931 7.5673 11.5267 7.92682C11.5277 7.92723 11.5286 7.92764 11.5296 7.92805L14.1155 9.03652L14.1611 9.06053C14.8987 9.44853 15.4827 10.3514 15.2477 11.3637C15.2476 11.3642 15.2475 11.3647 15.2474 11.3652L14.7035 13.7233C14.7034 13.7238 14.7033 13.7242 14.7032 13.7246C14.7031 13.7248 14.7032 13.7245 14.7032 13.7246C14.4902 14.6502 13.6699 15.3005 12.7224 15.3005C6.0915 15.3 0.700012 9.90867 0.700012 3.27742C0.700012 2.33106 1.34919 1.50919 2.27667 1.29673L4.63759 0.752177Z"
                      />
                    </svg>
                    <span className="text">Get In Touch</span>
                  </Button>
                </NavLink>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </Container>
    </header>
  );
};

export default Header;
